import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { IOrderStatusBody } from "../../../interfaces/IOrderStatus";
import { IDialogChildComponent } from "../../../reducers/dialog";
import APIExtensions from "../../../yoello-lib/modules/API2/APIDefs";
import { useAPIV2 } from "../../../yoello-lib/modules/API2/useAPIv2";
import { IProcessedOrders } from "../constants";
import Styles from "../../../scss/voidOrderDialog.module.scss"
import { Divider } from "@material-ui/core";
import { HTTPMethods } from "../../../yoello-lib/modules/API/API";
import ListLoading from "../../util/Loading";

interface IOrderDialogProps extends IDialogChildComponent {
    orderList: IProcessedOrders[];
    venueId: string;
    transformFunction: (orderList: IProcessedOrders[], ...args: any[]) => IOrderStatusBody[];
    title: string;
    refreshOrderList: () => void;
    errorLabel: string;
    transFormArgs: any[];
}


export function OrderDialog({
    orderList,
    transformFunction,
    onClose,
    refreshOrderList,
    title,
    errorLabel,
    transFormArgs = []
}: IOrderDialogProps) {
    const { t } = useTranslation();
    const { callAPI: callPlacedOrders } = useAPIV2(APIExtensions.placedOrders, { onMountDisabled: true, query: 'status', errorCall: t(`order.dialog.${errorLabel}`) });
    const [isLoading, setIsLoading] = useState(false);

    async function onSubmit() {
        setIsLoading(true);
        const body = transformFunction(orderList, [...transFormArgs]);
        const { isSuccessful } = await callPlacedOrders(HTTPMethods.PATCH, { body });
        setIsLoading(false);
        if (isSuccessful) {
            refreshOrderList();
            onClose();
        }
    }

    return isLoading ? <ListLoading /> : <div className={Styles.VoidOrderDialogContainer}>
      
        <Divider />
        <div className={Styles.Controllers}>
            <div>
                <p>
                    {t('order.dialog.actionInfo')}
                    <strong>
                        {t('order.dialog.actionBold')}
                    </strong>
                </p>
            </div>
            <div>
                <div onClick={onClose}>
                    <p>{t('misc.cancel')}</p>
                </div>
                <div onClick={onSubmit}>
                    <p>{t('misc.continue')}</p>
                </div>
            </div>
        </div>
    </div>
}